import { useEffect } from 'react';
import { ClientLocationDto } from '@/app/store/api/restApi';
import { setTakeoutAddress, useAppDispatch, useAppSelector } from '@/app/store';

export const useActualiseTakeout = ({
  locations,
  locationsLoading,
}: {
  locationsLoading: boolean;
  locations: ClientLocationDto[];
}) => {
  const dispatch = useAppDispatch();
  const { takeoutAddress } = useAppSelector((state) => state.order);

  useEffect(() => {
    if (!locationsLoading && takeoutAddress) {
      const takeAddressExists = locations.filter((l) => l.takeout?.isActive).find((l) => l.id === takeoutAddress);

      if (!takeAddressExists) dispatch(setTakeoutAddress(undefined));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, locations, locationsLoading]);
};
